// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qxJ7OtHJd09Eue {
  font-weight: var(--ds-font-weight-bold, 700);
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-050, 4px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  display: block;
  margin: var(--ds-space-0, 0);
}
.M3R57bSUt7atr2 {
  display: flex;
  margin-top: var(--ds-space-050, 4px);
}
.M3R57bSUt7atr2 .ynGJhvJfvU5ZR0 {
  margin-top: var(--ds-space-025, 2px);
  margin-left: var(--ds-space-050, 3px);
}
.M3R57bSUt7atr2 .cnSIqu3ZRHHyZL {
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-radius-small, 3px);
  width: 256px;
  max-height: 300px;
  margin-bottom: var(--ds-space-100, 8px);
  border-color: var(--ds-border, #091e4224);
  background-color: var(--ds-background-input, #ffffff);
  flex: 1;
  margin: var(--ds-space-0, 0);
}
.M3R57bSUt7atr2 .cnSIqu3ZRHHyZL option[disabled] {
  color: var(--ds-text-subtle, #44546f);
}
.M3R57bSUt7atr2 .cnSIqu3ZRHHyZL option[disabled] {
  color: var(--ds-text-subtle, #44546f);
}
.ukH6M9ponKODCt {
  display: flex;
  align-items: center;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: var(--ds-font-weight-regular, normal);
}
.ukH6M9ponKODCt .ynGJhvJfvU5ZR0 {
  margin-top: var(--ds-space-025, 2px);
  margin-left: var(--ds-space-050, 3px);
}
.ukH6M9ponKODCt .nmnaF4LsRPrH21 {
  flex: 1;
}
.l7YEWVamKhowTL .C3FBNkiy0kv90f {
  display: block;
  margin-top: var(--ds-space-050, 4px);
  padding: var(--ds-space-100, 8px);
}
.l7YEWVamKhowTL label {
  cursor: pointer;
}
`, ""]);
// Exports
export var colorVisionLabel = `qxJ7OtHJd09Eue`;
export var colorVisionOptions = `M3R57bSUt7atr2`;
export var checkbox = `ynGJhvJfvU5ZR0`;
export var select = `cnSIqu3ZRHHyZL`;
export var tota11yOptions = `ukH6M9ponKODCt`;
export var label = `nmnaF4LsRPrH21`;
export var accessibilityMenuWrapper = `l7YEWVamKhowTL`;
export var link = `C3FBNkiy0kv90f`;
export default ___CSS_LOADER_EXPORT___;
